import './../css/main.css';
import { initStickyHeader } from './modules/header.js';
import { initMobileNavigation } from './modules/navigation.js';
import { initEventCountdown } from './modules/countdown.js';
import { initTrainerFilter } from './modules/trainer-filter.js';
import { initFormEnhance } from './modules/form-enhance.js';
import { initFormsEmbed } from './modules/forms-embed.js';

document.addEventListener('DOMContentLoaded', () => {
  initStickyHeader();
  initMobileNavigation();
  initEventCountdown();
  initTrainerFilter();
  initFormEnhance();
  initFormsEmbed();
});
